import React, { useEffect, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Modal,
  NativeSelect,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
  Grid,
} from '@mui/material';

//date picker
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getYear } from 'date-fns';
import _ from 'lodash';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SearchIcon from '@mui/icons-material/Search';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { styled, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import ProjectSubCompoent from './ProjectSubCompoent';
import { ORGANIZATION_SERVER, POST_SERVER, CODE_SERVER } from '../../Config';
import { useForm } from 'react-hook-form';
import axios from 'axios';
axios.defaults.withCredentials = true;

const CustomGrid2 = styled(Grid)({
  minHeight: '60px',
});

const CustomGrid22 = styled(Grid)({
  padding: '16px 16px 0px 16px',
  // marginBottom: '4px',
});

const theme = createTheme({
  main: 'rgba(0, 0, 0, 0.6)',
  orange: orange[500],
});

const customerErrorModalstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const CustomFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});

const CustomRadio = styled(Radio)({
  width: '32px',
  height: '32px',
  marginLeft: '12px',
});

function ProjectPage() {
  const matches = useMediaQuery('(max-width:768px)');
  const { state } = useLocation();
  const [organizationList, setOrganizationList] = useState([]);
  const [dataTargetList, setDataTargetList] = useState([]);
  const [dataTypeList, setDataTypeList] = useState([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [errorMsgModalOpen, setErrorMsgModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const user = useSelector((state) => state.user.userData);
  //date picker
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const years = _.range(2000, getYear(new Date()) + 1, 1);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <Button
      variant="outlined"
      onClick={onClick}
      ref={ref}
      disabled={watch('date') !== 'daterange'}
      size="small"
      style={{ width: '220px' }}
      startIcon={<CalendarMonthIcon />}
    >
      {value}
    </Button>
  ));

  const handleErrorMsgModalClose = () => {
    setErrorMsg('');
    setErrorMsgModalOpen(false);
  };

  const { handleSubmit, register, setValue, watch } = useForm({
    defaultValues: {
      organization: 'None',
      title: '',
      date: 'All',
      daterange: '',
      dataTarget: 'None',
      dataType: 'None',
      page: page,
      isPagination: true,
    },
    // resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data, e) => {
    data.page = 1;
    axios.post(`${process.env.REACT_APP_SERVER}${POST_SERVER}/history`, data).then((res) => {
      setRows(res.data);
    });
  };

  useEffect(() => {
    if (state !== null) {
      setValue('organization', state.group);
      let data = {
        organization: watch('organization'),
        title: watch('title'),
        date: watch('date'),
        daterange: watch('daterange'),
        dataTarget: watch('dataTarget'),
        dataType: watch('dataType'),
        page: page,
        isPagination: true,
      };
      axios.get(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/list`).then((res) => {
        // console.log(res.data);
        // setValue('organization', state.group);
        setOrganizationList(res.data);
      });

      axios.get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/codecode/${20}`).then((res) => {
        // console.log(res.data);
        setDataTargetList(res.data);
      });

      axios.get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/codecode/domainall`).then((res) => {
        // console.log(res.data);
        setDataTypeList(res.data);
      });

      axios.post(`${process.env.REACT_APP_SERVER}${POST_SERVER}/history`, data).then((res) => {
        setRows(res.data);
      });
    }
  }, [state]);

  // daterange 이외 항목 라디오버튼 선택 -> daterange clear
  useEffect(() => {
    setDateRange([null, null]);
    setValue('daterange', [null, null]);
  }, [watch('date')]);

  const searchPage = () => {
    let data = {
      organization: watch('organization'),
      title: watch('title'),
      date: watch('date'),
      daterange: watch('daterange'),
      dataTarget: 'None',
      dataType: 'None',
      page: page,
      isPagination: true,
    };

    axios.post(`${process.env.REACT_APP_SERVER}${POST_SERVER}/history`, data).then((res) => {
      setRows(res.data);
    });
  };

  return (
    <div className="ProjectPage">
      <Grid container>
        <Grid
          size={12}
          container
          sx={
            matches
              ? { paddingTop: '100px', backgroundColor: '#e0e0e0' }
              : {
                  paddingTop: '148px',
                  backgroundColor: '#e0e0e0',
                }
          }
        >
          <Grid container sx={{ border: '1px solid  #757575' }} size={12}>
            <Grid
              container
              sx={{
                height: '100%',
                padding: '16px 8px 8px 16px',
              }}
              size={{
                xs: 10,
                // md: 10,
              }}
            >
              <Grid container direction="row" spacing={1} size={12}>
                <CustomGrid2 size={{ xs: 12, md: 6 }}>
                  <CustomFormControl variant="standard" size="small" fullWidth>
                    <InputLabel shrink htmlFor="organization">
                      Organization
                    </InputLabel>

                    <NativeSelect
                      id="organization"
                      label="Type"
                      fullWidth
                      {...register('organization')}
                      value={watch('organization') || 'None'}
                      disabled={user.role !== 'super admin'}
                    >
                      <option value={'None'}>All</option>
                      {organizationList &&
                        organizationList.map((v, i) => (
                          <option key={v._id} value={v._id}>
                            {`[${v.name}] - `}
                            {v.projectName !== undefined ? v.projectName : ''}
                          </option>
                        ))}
                    </NativeSelect>
                  </CustomFormControl>
                </CustomGrid2>

                <CustomGrid2 size={{ xs: 12, md: 3 }}>
                  <CustomFormControl variant="standard" size="small" fullWidth>
                    <InputLabel shrink htmlFor="dataTarget">
                      Data Target
                    </InputLabel>

                    <NativeSelect
                      id="dataTarget"
                      label="Type"
                      fullWidth
                      {...register('dataTarget')}
                      value={watch('dataTarget') || 'None'}
                      // disabled={!user.isAdmin}
                    >
                      <option value={'None'}>All</option>
                      {dataTargetList &&
                        dataTargetList.map((v, i) => (
                          <option key={v._id} value={v.code}>
                            {v.name}
                          </option>
                        ))}
                      {/* <option key={1} value={'한약재'}>
                        한약재
                      </option>
                      <option key={2} value={'사람'}>
                        사람
                      </option>
                      <option key={3} value={'동물'}>
                        동물
                      </option> */}
                    </NativeSelect>
                  </CustomFormControl>
                </CustomGrid2>
                <CustomGrid2 size={{ xs: 12, md: 3 }}>
                  <CustomFormControl variant="standard" size="small" fullWidth>
                    <InputLabel shrink htmlFor="dataType">
                      Data Type
                    </InputLabel>

                    <NativeSelect
                      id="dataType"
                      label="Type"
                      fullWidth
                      {...register('dataType')}
                      value={watch('dataType') || 'None'}
                    >
                      <option value={'None'}>All</option>
                      {[
                        { gubun: 1001, label: '분자·유전체 (Molecular & Genomic)' },
                        { gubun: 1002, label: '측정·영상 (Measurement & Imaging)' },
                        { gubun: 1003, label: '임상·문서 (Clinical & Documentary)' },
                      ].map(({ gubun, label }) => {
                        const group = dataTypeList.filter((v) => v.gubun === gubun);
                        if (!group.length) return null;
                        return (
                          <optgroup key={gubun} label={`── ${label} ──`}>
                            {group.map((v) => (
                              <option key={v._id} value={v.code}>
                                {v.name}
                              </option>
                            ))}
                          </optgroup>
                        );
                      })}
                    </NativeSelect>
                  </CustomFormControl>
                </CustomGrid2>

                <CustomGrid2 size={{ xs: 12, md: 6 }}>
                  <CustomFormControl>
                    <FormLabel id="date" sx={{ fontSize: '0.8rem' }}>
                      Search By Date
                    </FormLabel>
                    <RadioGroup id="date" name="radio-buttons-group" defaultValue="All" row>
                      <FormControlLabel
                        value="All"
                        control={<CustomRadio size="small" />}
                        label="All"
                        {...register('date')}
                      />
                      <FormControlLabel
                        value="Day"
                        control={<CustomRadio size="small" />}
                        label="Day"
                        {...register('date')}
                      />
                      <FormControlLabel
                        value="Week"
                        control={<CustomRadio size="small" />}
                        label="Week"
                        {...register('date')}
                      />
                      <FormControlLabel
                        value="Month"
                        control={<CustomRadio size="small" />}
                        label="Month"
                        {...register('date')}
                      />
                      <FormControlLabel
                        value="daterange"
                        control={<CustomRadio size="small" />}
                        {...register('date')}
                      ></FormControlLabel>
                      <DatePicker
                        dateFormat="yyyy/MM/dd"
                        customInput={<CustomInput />}
                        placeholderText={'From date to date'}
                        disabled={watch('date') !== 'daterange'}
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        minDate={new Date(2000, 0, 1)}
                        maxDate={new Date(getYear(new Date()), 11, 31)}
                        onChange={(update) => {
                          setDateRange(update);
                          setValue('daterange', update);
                        }}
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                              {'<'}
                            </button>
                            <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
                              {years.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <select
                              value={months[date.getMonth(date)]}
                              onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                            >
                              {months.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                              {'>'}
                            </button>
                          </div>
                        )}
                      />
                    </RadioGroup>
                  </CustomFormControl>
                </CustomGrid2>
              </Grid>
            </Grid>
            <CustomGrid2 size="grow" style={{ padding: '24px' }}>
              <Button
                type="submit"
                variant="contained"
                // color="error"
                onClick={handleSubmit(onSubmit)}
                fullWidth
                sx={{ height: '100%', fontSize: 20, textTransform: 'none' }}
              >
                <SearchIcon sx={{ fontSize: 32 }} />
                Search
              </Button>
            </CustomGrid2>
          </Grid>
        </Grid>
        <CustomGrid22
          size={{ xs: 12 }}
          style={{
            // display: 'inline-flex',
            // flexDirection: 'column',
            // overflow: 'hidden',
            // overflowY: 'scroll',
            backgroundColor: 'white',
            paddingBottom: '100px',
            width: '100%',
          }}
        >
          <ProjectSubCompoent rows={rows} reloadList={handleSubmit(onSubmit)} />
        </CustomGrid22>
      </Grid>
      <Modal
        open={errorMsgModalOpen}
        onClose={handleErrorMsgModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={customerErrorModalstyle}>
          <ErrorOutlineRoundedIcon color="warning" style={{ fontSize: 64 }} />
          <Typography id="modal-title" style={{ margin: 16, fontWeight: 600, fontSize: '24px' }}>
            {errorMsg}
          </Typography>
          <Button variant="contained" color="error" size="small" onClick={handleErrorMsgModalClose}>
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default ProjectPage;
